// +----------------------------------------------------------------------
// | 用户资料 / 偏好设置 / 统计
// +----------------------------------------------------------------------
import request from '../lib/request';

/** 获取资料（users + user_profiles 合并返回） */
export function getProfile() {
  return request.get('/user/profile');
}

/**
 * 修改资料（部分更新，只传要改的字段）
 * nickname / avatar 存 users 表，gender / birthday / occupation / intro 存 user_profiles 表
 * @param {{nickname?:string, avatar?:string, gender?:number, birthday?:string, occupation?:string, intro?:string}} data
 */
export function updateProfile(data) {
  return request.put('/user/profile', data);
}

/** 获取偏好设置 */
export function getSettings() {
  return request.get('/user/settings');
}

/**
 * 修改偏好设置
 * @param {{memory_enabled?:number, quick_max_questions?:number, ai_tone?:string}} data
 */
export function updateSettings(data) {
  return request.put('/user/settings', data);
}

/** 决策统计：total / decided / feedback */
export function getStats() {
  return request.get('/user/stats');
}
